export default __webpack_public_path__ + "static/media/golf_bg_000.a2753404.jpg";